import React from "react";
import PropTypes from "prop-types";
import Routes from "./Routes";
import ProtectedRoute from "./ProtectedRoute";
import { withUserNavbar } from "../../modules/utils";
import StyledWrappers from "./ComponentWithLayout";

const RouteWithSubRoutes = (route) => {
  if (!route.component && !route.routes && !route.genericRoute) {
    return null;
  }

  const Component =
    route.withNavbar && route.isLoggedIn
      ? withUserNavbar(route.component || Routes)
      : route.component || Routes;
  return (
    <ProtectedRoute
      authorize={route.authorize}
      study={route.study}
      genericRoute={route?.genericRoute || false}
      redirectNonAuthorized={route.redirectNonAuthorized}
      unauthorizedStudyStatus={route.unauthorizedStudyStatus}
      redirectNonStudyEnrolled={route.redirectNonStudyEnrolled}
      onRouteChange={route.onRouteChange}
      onProtectedRouteChange={route.onProtectedRouteChange}
      path={route.path}
      render={(props) =>
        route.fullpage === true ? (
          <StyledWrappers.ComponentWithTheme>
            <Component {...props} route={route} routes={route.routes} />
          </StyledWrappers.ComponentWithTheme>
        ) : (
          <StyledWrappers.ComponentWithLayout
            route={route}
            withSidebar={route.withSidebar}
          >
            <Component
              {...props}
              withSidebar={route.withSidebar}
              route={route}
              routes={route.routes}
            />
          </StyledWrappers.ComponentWithLayout>
        )
      }
    />
  );
};

const requireComponentOrRoutes = (props, propName, componentName) => {
  if (
    !props.component &&
    (!props.routes || props.routes.length === 0) &&
    !props.genericRoute
  ) {
    return new Error(
      `One of 'component','routes' or 'genericRoute' is required by '${componentName}' component.`
    );
  }

  // additional standard rules
  const propTypes = {
    routes: PropTypes.arrayOf(PropTypes.object),
  };
  PropTypes.checkPropTypes(propTypes, props, "prop", componentName);
};

RouteWithSubRoutes.propTypes = {
  path: PropTypes.string.isRequired,
  redirectNonAuthorized: PropTypes.string,
  redirectNonStudyEnrolled: PropTypes.string,
  routes: requireComponentOrRoutes,
  authorize: PropTypes.arrayOf(PropTypes.string),
};

export default RouteWithSubRoutes;
